export default __webpack_public_path__ + "static/media/wrong1-a.bf838dfb.png";